import { junglerUserEpic as epic } from "./epic";
import { junglerUserReducer as reducer } from "./reducer";

export const junglerUserEpic = epic
export const junglerUserReducer = reducer
